import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import Flex from './Flex';
import Radio from './form/Radio';
import Text from './Text';
const isRefined = (value, currentRefinement) => {
  if (!currentRefinement) return false;
  return currentRefinement.includes(value);
};
const AlgoliaRadioRefinement = /*#__PURE__*/React.memo(_ref => {
  let {
    allLabel = 'All',
    attribute,
    currentRefinement,
    flexDirection = 'row',
    fontSize = 1,
    gutter = 18,
    items: algoliaItems,
    itemsOverride,
    refine
  } = _ref;
  const items = itemsOverride ? itemsOverride.map(item => ({
    ...item,
    isRefined: isRefined(item.value, currentRefinement)
  })) : algoliaItems;
  const inputs = allLabel ? [{
    label: allLabel,
    value: '',
    isRefined: !currentRefinement || Array.isArray(currentRefinement) && currentRefinement.length === 0
  }, ...items] : items;
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: flexDirection,
    fontSize: fontSize
  }, inputs.map((item, i) => /*#__PURE__*/React.createElement(Flex, {
    key: item.label,
    as: "label",
    sx: {
      alignItems: 'center',
      ml: i !== 0 && flexDirection === 'row' ? gutter : 0
    }
  }, /*#__PURE__*/React.createElement(Radio, {
    onChange: e => refine(e.target.value),
    value: item.value,
    checked: item.isRefined
  }), /*#__PURE__*/React.createElement(Text, {
    sx: {
      '&:hover': {
        color: 'secondary',
        textDecoration: 'underline'
      }
    }
  }, item.label))));
});
AlgoliaRadioRefinement.propTypes = {};
AlgoliaRadioRefinement.displayName = 'AlgoliaRadioRefinement';
export default connectRefinementList(AlgoliaRadioRefinement);